// Archived projects - /personal-area/projects/archived.
//
// The projects a card's archive button sent out of My Projects, for the
// signed-in member. Same cards, same list route with ?archived=1; the
// card's archive button restores from here and the row leaves the page.
// Editing, sharing and deleting wait until the project is restored.
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { MDBRow } from "mdbreact";
import { Empty } from "antd";
import ProjectItemPersonalArea from "components/ProjectItemPersonalArea";
import Loader from "components/Loader";
import addNotification from "helpers/notify";
import { getArchivedProjects } from "api/projects/archiveProject";

export default function ArchivedProjectsPage() {
  const history = useHistory();
  const userInfoRedux = useSelector((s) => s.user.userInfo) || {};
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    getArchivedProjects()
      .then((r) => { if (alive) setProjects(Array.isArray(r?.projects) ? r.projects : []); })
      .catch((e) => { if (alive) setError(e?.err || e?.message || "Could not list the archived projects"); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const restoreFirst = () => addNotification("Restore the project to My Projects first", "warning");
  const { companyAdmin, admin } = userInfoRedux;

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="personal-area">
        <div className="inner-header-position">
          <div className="custom-container d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex align-items-center">
              <div onClick={() => history.push("/personal-area")} className="cursor-pointer" title="Back to My Projects">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
                  <path d="M6.84102 8.825L3.02435 5L6.84102 1.175L5.66602 0L0.666016 5L5.66602 10L6.84102 8.825Z" fill="#9E9E9E" />
                </svg>
              </div>
              <p className="my-heading f-14 ml-3 mr-3">Archived projects{projects.length ? ` (${projects.length})` : ""}</p>
            </div>
            <div className="projActionButtons d-flex flex-wrap">
              <div className="btn-tool-group">
                <button onClick={() => history.push("/personal-area")} className="px-3 bg-white text-bid shadow-hover">
                  Back to My Projects
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-container">
          {error ? (
            <div style={{ padding: 24, color: "#9A3412" }}>{error}</div>
          ) : !loading && !projects.length ? (
            <div style={{ padding: 40 }} data-testid="archived-empty">
              <Empty description="No archived projects. A card's archive button sends a project here." />
            </div>
          ) : (
            <MDBRow className="row-cols-lg-3 row-cols-sm-2 row-cols-1 mt-3">
              {projects.map((projectItem, index) => (
                <ProjectItemPersonalArea
                  key={projectItem._id}
                  archived
                  isAdmin={companyAdmin || admin}
                  className={index > 2 ? "mt-4" : ""}
                  projectItem={projectItem}
                  idUser={userInfoRedux._id || userInfoRedux.id}
                  isParent={projectItem.isParent}
                  parentProjectID={projectItem.parentProjectID}
                  onArchived={(p) => setProjects((prev) => prev.filter((x) => x._id !== p._id))}
                  openUpdateModal={restoreFirst}
                  openDeleteModal={restoreFirst}
                  openMembersModal={restoreFirst}
                  openShareModal={restoreFirst}
                />
              ))}
            </MDBRow>
          )}
        </div>
      </div>
    </>
  );
}
